import type { EndpointSpec, Translate } from '../../../components/apidocs';

/** Orders API (Payin) — QR flow */
export const ORDERS_ENDPOINTS = (t: Translate): EndpointSpec[] => [
  {
    method: 'POST',
    path: '/orders',
    description: t('apiDocs.createOrderDesc'),
    requests: [{
      heading: 'Request Body',
      variant: 'required',
      rows: [
        { name: 'amount', type: 'number', required: true, description: t('apiDocs.fieldAmountBaht') },
        { name: 'reference_id', type: 'string', required: true, description: t('apiDocs.fieldReferenceId') },
        { name: 'bank_name', type: 'string', required: true, description: t('apiDocs.fieldBankName') },
        { name: 'bank_number', type: 'string', required: true, description: t('apiDocs.fieldBankNumber') },
        { name: 'customer_name', type: 'string', description: t('apiDocs.fieldCustomerName') },
        { name: 'customer_email', type: 'string', description: t('apiDocs.fieldCustomerEmail') },
        { name: 'customer_phone', type: 'string', description: t('apiDocs.fieldCustomerPhone') },
        { name: 'callback_url', type: 'string', description: t('apiDocs.fieldCallbackUrl') },
        { name: 'redirect_url', type: 'string', description: t('apiDocs.fieldRedirectUrl') },
      ],
    }],
    response: {
      status: 201,
      id: 'create-order-res',
      code: `{
  "success": true,
  "message": "สร้าง Order สำเร็จ",
  "data": {
    "order_number": "ORD_abc123xyz",
    "amount": 100.00,
    "total_amount": 100.45,
    "qr_code": "data:image/png;base64,...",
    "status": "pending",
    "expires_at": "2025-10-09T12:35:29.000Z",
    "expires_in_seconds": 300,
    "payment_url": "https://123pay.asia/pay/ORD_abc123xyz",
    "redirect_url": "https://your-site.com/thank-you"
  }
}`,
    },
  },
  {
    method: 'GET',
    path: '/orders/:order_number',
    description: t('apiDocs.checkOrderStatus'),
    response: {
      status: 200,
      id: 'get-order-res',
      code: `{
  "success": true,
  "data": {
    "order_number": "ORD_abc123xyz",
    "reference_id": "YOUR-ORDER-123",
    "amount": 100.00,
    "total_amount": 100.45,
    "status": "paid",
    "created_at": "2025-10-09T12:30:29.000Z",
    "expires_at": "2025-10-09T12:35:29.000Z",
    "paid_at": "2025-10-09T12:32:15.000Z",
    "seconds_left": 0,
    "is_expired": false
  }
}`,
    },
    statuses: ['pending', 'paid', 'expired', 'cancelled'],
  },
  {
    method: 'GET',
    path: '/orders',
    description: t('apiDocs.getOrdersList'),
    requests: [{
      heading: 'Query Parameters',
      variant: 'default',
      rows: [
        { name: 'status', type: 'string', description: t('apiDocs.fieldFilterStatus') },
        { name: 'limit', type: 'number', default: '50', description: t('apiDocs.fieldLimit') },
        { name: 'offset', type: 'number', default: '0', description: t('apiDocs.fieldOffset') },
      ],
    }],
    response: {
      status: 200,
      id: 'list-orders-res',
      code: `{
  "success": true,
  "data": [
    {
      "order_number": "ORD_abc123xyz",
      "base_amount": 100.00,
      "total_amount": 100.45,
      "status": "paid",
      "customer_name": "นาย A",
      "created_at": "2025-10-09T12:30:29.000Z",
      "paid_at": "2025-10-09T12:32:15.000Z"
    }
  ],
  "pagination": {
    "total": 150,
    "limit": 50,
    "offset": 0
  }
}`,
    },
  },
];
